<template>
  <v-container v-if="isLoading">
    <v-row>
      <v-col
        v-for="i in loader.items"
        :key="i"
      >
        <v-skeleton-loader
          class="ma-2"
          :type="loader.template"
        />
      </v-col>
    </v-row>
  </v-container>
  <div v-else>
    <slot />
  </div>
</template>

<script>
import { isFetching } from '@/store/getters'
import { mapGetters } from 'vuex'

export default {
  name: 'SkeletonTableLoader',
  props: {
    itemsLength: Number,
    type: {
      type: String,
      default: 'table'
    }
  },
  data () {
    return {
      types: {
        table: {
          template: 'table-thead, table-tbody',
          items: [1]
        },
        cards: {
          template: 'card-avatar, article, actions',
          items: [1, 2, 3]
        }
      }
    }
  },
  computed: {
    ...mapGetters([isFetching]),
    isLoading () {
      return this.isFetching && !this.itemsLength
    },
    loader () {
      return this.types[this.type]
    }
  }
}
</script>
